import type { NotifyMePopupConfig } from '../models';

const parseSpaConfig = (config: string) => {
    if (!config) {
        throw new Error('No config provided!');
    }

    return JSON.parse(config) as NotifyMePopupConfig;
};

export const getConfiguration = (element: HTMLElement): NotifyMePopupConfig => {
    const finalConfig = parseSpaConfig(element.dataset.config as string);

    if (!finalConfig.tenant) {
        throw new Error('Missing config values!');
    }

    return finalConfig;
};
